import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@cobliteam/ui/form';
import InputMask from '@cobliteam/ui/form/InputMask';

const DriverCNHInput = () => {
  return (
    <FormField name='driverLicense'>
      {({ field }) => {
        return (
          <FormItem className='w-full space-y-1'>
            <FormLabel>CNH</FormLabel>
            <FormControl>
              <InputMask name='driverLicense' mask='___.___.___.__' replacement={{ _: /\d/ }} onChange={field.onChange} value={field.value || ''} placeholder='Nº do CNH' />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    </FormField>
  );
};

export default DriverCNHInput;
